export default __webpack_public_path__ + "static/media/GoldenPalace.3eca9784.jpg";